"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _Loader = require("../Loader");

var TooltipMessage = function TooltipMessage(titleTooltip) {
  if (!titleTooltip) return '';
  return (0, _preact.h)("div", null, titleTooltip.map(function (text, index) {
    return (0, _preact.h)("p", {
      key: index
    }, text);
  }));
};

var MetricsRow = function MetricsRow(_ref) {
  var children = _ref.children,
      title = _ref.title,
      titleTooltipTexts = _ref.titleTooltipTexts,
      isLoading = _ref.isLoading;
  return (0, _preact.h)("div", {
    className: "metrics-row metric-summary"
  }, (0, _preact.h)("div", {
    className: "metrics-row-header"
  }, title, titleTooltipTexts && titleTooltipTexts.length > 0 && (0, _preact.h)(_Tooltip.default, {
    position: "center",
    trigger: (0, _preact.h)(_assets.default, {
      icon: "question",
      size: 16,
      customClass: "icon-info"
    }),
    customClasses: "metric-help-tooltip",
    tooltipMessage: TooltipMessage(titleTooltipTexts)
  })), isLoading ? (0, _preact.h)(_Loader.Loader, null) : children);
};

var _default = MetricsRow;
exports.default = _default;